import React from 'react';
import { AvailabilityIndicator, BodyText, Flex } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

export const Availability = ({ availableAmount }: { availableAmount?: number }) => {
  const { t } = useTranslation('bundlesview');
  let AvailabilityContent;
  if (!availableAmount || availableAmount < 0) {
    AvailabilityContent = (
      <AvailabilityIndicator color="red600">
        <BodyText>{t('bundles_table.noStock')}</BodyText>
      </AvailabilityIndicator>
    );
  } else if (availableAmount > 10) {
    AvailabilityContent = (
      <AvailabilityIndicator color="green500">
        <BodyText>{t('bundles_table.available')}</BodyText>
      </AvailabilityIndicator>
    );
  } else if (availableAmount > 0 && availableAmount <= 10) {
    AvailabilityContent = (
      <AvailabilityIndicator color="orange400">
        <BodyText>{t('bundles_table.limited')}</BodyText>
      </AvailabilityIndicator>
    );
  }
  return <Flex centeredVertically>{AvailabilityContent}</Flex>;
};
